import React, { useEffect, useState, useRef } from 'react';
import api from '../api';

const GST_PRESETS = [
  { label: 'No GST', value: 0 },
  { label: '2%',     value: 2 },
  { label: '3%',     value: 3 },
  { label: '5%',     value: 5 },
  { label: '12%',    value: 12 },
  { label: '18%',    value: 18 },
  { label: '28%',    value: 28 },
  { label: 'Custom', value: -1 },
];

const PRINT_STYLE = `
@media print {
  body * { visibility: hidden !important; }
  #bill-print-area, #bill-print-area * {
    visibility: visible !important;
  }
  #bill-print-area {
    position: fixed !important;
    top: 0; left: 0;
    width: 100% !important;
    z-index: 9999;
  }
  @page { margin: 10mm; }
}
`;

function normaliseItems(items = []) {
  return items.map(item => ({
    name:       item.name       || item.item_name       || item.product_name  || '—',
    name_tamil: item.name_tamil || item.item_name_tamil || item.product_tamil || '',
    qty:        parseFloat(item.qty ?? item.quantity ?? 1),
    price:      parseFloat(item.price ?? item.unit_price ?? item.rate ?? 0),
    mrp:        item.mrp ? parseFloat(item.mrp) : null,  // ✅ FIX — TODAY SAVING works now!
  }));
}

// ═══════════════════════════════════════════
// A4 BILL — ✅ shop name from bill.shopName
// ═══════════════════════════════════════════
function A4Bill({ bill }) {
  if (!bill) return null;
  const shop  = bill.shopName || 'என் கடை'; // ✅ CHANGE 1
  const items = normaliseItems(bill.items);
  const today = new Date().toLocaleDateString('ta-IN', {
    year: 'numeric', month: 'long', day: 'numeric'
  });

  return (
    <div style={{ fontFamily: 'Arial', padding: '20px', maxWidth: '750px', margin: '0 auto', background: 'white' }}>
      <div style={{ textAlign: 'center', borderBottom: '3px solid #2c3e50', paddingBottom: '16px', marginBottom: '16px' }}>
        <h1 style={{ margin: 0, fontSize: '26px', color: '#2c3e50', fontWeight: '900' }}>🏪 {shop}</h1>
        <p style={{ margin: '4px 0 0', color: '#999', fontSize: '10px' }}>Powered by JSMSTOCK.COM</p>
        <h2 style={{ margin: '6px 0 0', fontSize: '14px', color: '#C9A84C', letterSpacing: '3px' }}>TAX INVOICE</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '16px' }}>
        <div>
          <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>பில் விவரங்கள்:</div>
          <div style={{ fontWeight: '700', fontSize: '15px' }}>Bill No: #{bill.billNumber}</div>
          <div style={{ fontSize: '13px', color: '#555' }}>தேதி: {today}</div>
        </div>
        <div>
          <div style={{ fontSize: '13px', color: '#666', marginBottom: '4px' }}>வாடிக்கையாளர்:</div>
          <div style={{ fontWeight: '700', fontSize: '15px' }}>{bill.customerName || '—'}</div>
          {bill.customerPhone && <div style={{ fontSize: '13px' }}>📱 {bill.customerPhone}</div>}
          {bill.customerGstin && <div style={{ fontSize: '13px' }}>GSTIN: {bill.customerGstin}</div>}
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '16px' }}>
        <thead>
          <tr style={{ background: '#2c3e50' }}>
            <th style={{ padding: '10px', color: 'white', textAlign: 'left',  fontSize: '13px' }}>#</th>
            <th style={{ padding: '10px', color: 'white', textAlign: 'left',  fontSize: '13px' }}>பொருள்</th>
            <th style={{ padding: '10px', color: 'white', textAlign: 'right', fontSize: '13px' }}>அளவு</th>
            <th style={{ padding: '10px', color: 'white', textAlign: 'right', fontSize: '13px' }}>விலை</th>
            <th style={{ padding: '10px', color: 'white', textAlign: 'right', fontSize: '13px' }}>மொத்தம்</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr><td colSpan={5} style={{ padding: '16px', textAlign: 'center', color: '#999', fontSize: '13px' }}>பொருட்கள் இல்லை</td></tr>
          ) : (
            items.map((item, i) => (
              <tr key={i} style={{ background: i % 2 === 0 ? 'white' : '#f8f9fa' }}>
                <td style={{ padding: '9px 10px', fontSize: '13px', borderBottom: '1px solid #eee' }}>{i + 1}</td>
                <td style={{ padding: '9px 10px', fontSize: '13px', borderBottom: '1px solid #eee', fontWeight: '600' }}>
                  {item.name_tamil || item.name}
                  {item.name_tamil && <div style={{ fontSize: '11px', color: '#999' }}>{item.name}</div>}
                </td>
                <td style={{ padding: '9px 10px', fontSize: '13px', borderBottom: '1px solid #eee', textAlign: 'right' }}>{item.qty}</td>
                <td style={{ padding: '9px 10px', fontSize: '13px', borderBottom: '1px solid #eee', textAlign: 'right' }}>₹{item.price}</td>
                <td style={{ padding: '9px 10px', fontSize: '13px', borderBottom: '1px solid #eee', textAlign: 'right', fontWeight: '700' }}>
                  ₹{(item.qty * item.price).toFixed(2)}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
        <div style={{ width: '280px', background: '#f8f9fa', padding: '16px', borderRadius: '8px', border: '1px solid #eee' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '14px' }}>
            <span>Subtotal</span><span>₹{bill.subtotal.toFixed(2)}</span>
          </div>
          {bill.discount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '14px', color: '#27ae60' }}>
              <span>Discount ({bill.discount}%)</span><span>-₹{bill.discountAmt.toFixed(2)}</span>
            </div>
          )}
          {bill.gstRate > 0 && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '13px', color: '#888' }}>
                <span>CGST ({bill.gstRate / 2}%)</span><span>₹{(bill.gstAmount / 2).toFixed(2)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', fontSize: '13px', color: '#888' }}>
                <span>SGST ({bill.gstRate / 2}%)</span><span>₹{(bill.gstAmount / 2).toFixed(2)}</span>
              </div>
            </>
          )}
          <div style={{ borderTop: '2px solid #2c3e50', marginTop: '8px', paddingTop: '8px', display: 'flex', justifyContent: 'space-between', fontWeight: '900', fontSize: '18px', color: '#2c3e50' }}>
            <span>💰 மொத்தம்</span><span>₹{bill.grandTotal.toFixed(2)}</span>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', borderTop: '2px dashed #ccc', paddingTop: '12px', color: '#888', fontSize: '12px' }}>
        <p style={{ margin: '4px 0', fontWeight: '700', color: '#2c3e50' }}>நன்றி! மீண்டும் வாருங்கள்! 🙏</p>
        <p style={{ margin: '4px 0' }}>Powered by JSMSTOCK.COM</p>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════
// THERMAL BILL — ✅ shop name from bill.shopName
// ═══════════════════════════════════════════
function ThermalBill({ bill }) {
  if (!bill) return null;
  const shop    = bill.shopName || 'என் கடை'; // ✅ CHANGE 2
  const items   = normaliseItems(bill.items);
  const today   = new Date().toLocaleDateString('ta-IN');
  const divider = '─'.repeat(32);

  return (
    <div style={{ fontFamily: 'monospace', width: '280px', padding: '8px', margin: '0 auto', background: 'white', fontSize: '12px', lineHeight: '1.6' }}>
      <div style={{ textAlign: 'center', marginBottom: '6px' }}>
        <div style={{ fontSize: '15px', fontWeight: '900' }}>🏪 {shop}</div>
        <div style={{ fontSize: '10px', color: '#555' }}>Powered by JSMSTOCK</div>
        <div style={{ fontSize: '11px', fontWeight: '700', marginTop: '2px' }}>TAX INVOICE</div>
      </div>
      <div style={{ textAlign: 'center', fontSize: '10px' }}>{divider}</div>
      <div style={{ fontSize: '11px', margin: '4px 0' }}>
        <div>Bill No : #{bill.billNumber}</div>
        <div>தேதி    : {today}</div>
        {bill.customerName  && <div>வாடிக்கை: {bill.customerName}</div>}
        {bill.customerPhone && <div>Phone   : {bill.customerPhone}</div>}
      </div>
      <div style={{ textAlign: 'center', fontSize: '10px' }}>{divider}</div>
      <div style={{ margin: '4px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', fontSize: '11px', marginBottom: '2px' }}>
          <span>பொருள்</span><span>மொத்தம்</span>
        </div>
        {items.length === 0 ? (
          <div style={{ fontSize: '11px', color: '#999', textAlign: 'center' }}>பொருட்கள் இல்லை</div>
        ) : (
          items.map((item, i) => (
            <div key={i} style={{ marginBottom: '3px', fontSize: '11px' }}>
              <div style={{ fontWeight: '600' }}>{item.name_tamil || item.name}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: '#555' }}>
                <span>{item.qty} × ₹{item.price}</span>
                <span>₹{(item.qty * item.price).toFixed(2)}</span>
              </div>
            </div>
          ))
        )}
      </div>
      <div style={{ textAlign: 'center', fontSize: '10px' }}>{divider}</div>
      <div style={{ margin: '4px 0', fontSize: '11px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>Subtotal</span><span>₹{bill.subtotal.toFixed(2)}</span>
        </div>
        {bill.discount > 0 && (
          <div style={{ display: 'flex', justifyContent: 'space-between', color: '#27ae60' }}>
            <span>Discount {bill.discount}%</span><span>-₹{bill.discountAmt.toFixed(2)}</span>
          </div>
        )}
        {bill.gstRate > 0 && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#888' }}>
              <span>CGST {bill.gstRate / 2}%</span><span>₹{(bill.gstAmount / 2).toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#888' }}>
              <span>SGST {bill.gstRate / 2}%</span><span>₹{(bill.gstAmount / 2).toFixed(2)}</span>
            </div>
          </>
        )}
      </div>
      <div style={{ textAlign: 'center', fontSize: '10px' }}>{divider}</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900', fontSize: '14px', margin: '4px 0' }}>
        <span>மொத்தம்</span><span>₹{bill.grandTotal.toFixed(2)}</span>
      </div>
      <div style={{ textAlign: 'center', fontSize: '10px' }}>{divider}</div>
      <div style={{ textAlign: 'center', fontSize: '10px', margin: '4px 0' }}>
        <div style={{ fontWeight: '700' }}>நன்றி! மீண்டும் வாருங்கள்! 🙏</div>
        <div style={{ color: '#888', marginTop: '2px' }}>Powered by JSMSTOCK.COM</div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════
// PRINT MODAL
// ═══════════════════════════════════════════

// ═══════════════════════════════════════════
// PREMIUM A4 BILL — Kumar Super Market style!
// ✅ Address + Phone + GSTIN + MRP + SAVING
// ═══════════════════════════════════════════
function PremiumA4Bill({ bill }) {
  if (!bill) return null;
  const shop      = bill.shopName    || 'என் கடை';
  const address   = bill.shopAddress || '';
  const shopPhone = bill.shopPhone   || '';
  const shopGstin = bill.shopGstin   || '';
  const items     = normaliseItems(bill.items || []);
  const subtotal  = bill.subtotal || items.reduce((s,i)=>s+(i.qty*i.price),0);
  const gstRate   = bill.gstRate  || 0;
  const gstAmt    = bill.gstAmount|| subtotal*(gstRate/100);
  const discAmt   = bill.discountAmt || 0;
  const grandTotal= bill.grandTotal || (subtotal-discAmt+gstAmt);
  const today     = new Date().toLocaleDateString('en-IN');
  const timeNow   = new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'});
  const mrpSaving = items.reduce((s,i)=>s+(i.qty*((i.mrp||i.price)-i.price)),0);

  return (
    <div style={{fontFamily:'Arial',padding:'20px',maxWidth:'750px',margin:'0 auto',background:'white'}}>
      <div style={{textAlign:'center',borderBottom:'3px solid #2c3e50',paddingBottom:'14px',marginBottom:'12px'}}>
        <h1 style={{margin:0,fontSize:'22px',color:'#2c3e50',fontWeight:'900',letterSpacing:'1px'}}>{shop}</h1>
        {address   && <p style={{margin:'3px 0',color:'#555',fontSize:'12px'}}>{address}</p>}
        {shopPhone && <p style={{margin:'3px 0',color:'#555',fontSize:'12px'}}>PH: {shopPhone}</p>}
        {shopGstin && <p style={{margin:'3px 0',fontWeight:'700',fontSize:'12px'}}>GST NO: {shopGstin}</p>}
        <p style={{margin:'4px 0 0',color:'#999',fontSize:'10px'}}>Powered by JSMSTOCK.COM</p>
      </div>
      <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',borderBottom:'1px dashed #ccc',paddingBottom:'6px',marginBottom:'6px'}}>
        <span>User: <b>ADMIN</b></span>
        <span>Bill No: <b>#{bill.billNumber||bill.bill_number}</b></span>
      </div>
      <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',borderBottom:'1px dashed #ccc',paddingBottom:'6px',marginBottom:'10px'}}>
        <span>Time: <b>{timeNow}</b></span>
        <span>Date: <b>{today}</b></span>
      </div>
      {/* ✅ Customer details section */}
      {(bill.customerName||bill.customer_name) && (
        <div style={{
          marginBottom:'10px',padding:'8px 12px',
          background:'#f8f9fa',borderRadius:'6px',
          border:'1px solid #eee',fontSize:'12px',
        }}>
          <div style={{display:'flex',justifyContent:'space-between',flexWrap:'wrap',gap:'4px'}}>
            <div>
              <b>Customer:</b> {bill.customerName||bill.customer_name}
            </div>
            {(bill.customerPhone||bill.customer_phone) && (
              <div>📱 <b>{bill.customerPhone||bill.customer_phone}</b></div>
            )}
          </div>
          {(bill.customerAddress||bill.customer_address) && (
            <div style={{marginTop:'3px',color:'#555'}}>
              📍 {bill.customerAddress||bill.customer_address}
            </div>
          )}
          {(bill.customerGstin||bill.customer_gstin) && (
            <div style={{marginTop:'3px',fontWeight:'700'}}>
              GST: {bill.customerGstin||bill.customer_gstin}
            </div>
          )}
        </div>
      )}
      <table style={{width:'100%',borderCollapse:'collapse',marginBottom:'10px'}}>
        <thead>
          <tr style={{background:'#2c3e50'}}>
            {['Description','Qty','RATE','MRP','Amount'].map((h,i)=>(
              <th key={i} style={{padding:'8px',color:'white',fontSize:'11px',textAlign:i===0?'left':'right'}}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item,i)=>(
            <tr key={i} style={{borderBottom:'1px dashed #eee'}}>
              <td style={{padding:'7px 8px',fontSize:'11px'}}>{item.name_tamil||item.name}</td>
              <td style={{padding:'7px 8px',fontSize:'11px',textAlign:'right'}}>{item.qty}</td>
              <td style={{padding:'7px 8px',fontSize:'11px',textAlign:'right'}}>{Number(item.price).toFixed(2)}</td>
              <td style={{padding:'7px 8px',fontSize:'11px',textAlign:'right'}}>{Number(item.mrp||item.price).toFixed(2)}</td>
              <td style={{padding:'7px 8px',fontSize:'11px',textAlign:'right',fontWeight:'700'}}>{(item.qty*item.price).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{borderTop:'1px dashed #ccc',paddingTop:'8px'}}>
        <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',margin:'3px 0'}}>
          <span>Total Qty</span><span><b>{items.reduce((s,i)=>s+i.qty,0)}</b></span>
        </div>
        {gstRate>0 && <>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',margin:'3px 0',color:'#666'}}>
            <span>CGST ({gstRate/2}%)</span><span>₹{(gstAmt/2).toFixed(2)}</span>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',margin:'3px 0',color:'#666'}}>
            <span>SGST ({gstRate/2}%)</span><span>₹{(gstAmt/2).toFixed(2)}</span>
          </div>
        </>}
        <div style={{display:'flex',justifyContent:'space-between',fontWeight:'900',fontSize:'18px',color:'#2c3e50',borderTop:'2px solid #2c3e50',marginTop:'6px',paddingTop:'6px'}}>
          <span>Net Amount</span><span>₹{Number(grandTotal).toFixed(2)}</span>
        </div>
        {mrpSaving > 0 && (
          <div style={{display:'flex',justifyContent:'space-between',fontSize:'13px',color:'#27ae60',fontWeight:'700',marginTop:'4px'}}>
            <span>TODAY SAVING</span><span>{mrpSaving.toFixed(2)}</span>
          </div>
        )}
      </div>
      <div style={{textAlign:'center',borderTop:'2px dashed #ccc',marginTop:'12px',paddingTop:'10px',color:'#888',fontSize:'11px'}}>
        <p style={{margin:'3px 0',fontWeight:'700',color:'#2c3e50'}}>நன்றி! மீண்டும் வாருங்கள்! 🙏</p>
        <p style={{margin:'3px 0'}}>Powered by JSMSTOCK.COM</p>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════
// PREMIUM THERMAL BILL — 80mm Kumar style!
// ═══════════════════════════════════════════
function PremiumThermalBill({ bill }) {
  if (!bill) return null;
  const shop      = bill.shopName    || 'என் கடை';
  const address   = bill.shopAddress || '';
  const shopPhone = bill.shopPhone   || '';
  const shopGstin = bill.shopGstin   || '';
  const items     = normaliseItems(bill.items || []);
  const subtotal  = bill.subtotal || items.reduce((s,i)=>s+(i.qty*i.price),0);
  const gstRate   = bill.gstRate  || 0;
  const gstAmt    = bill.gstAmount|| subtotal*(gstRate/100);
  const grandTotal= bill.grandTotal || (subtotal+gstAmt);
  const today     = new Date().toLocaleDateString('en-IN');
  const timeNow   = new Date().toLocaleTimeString('en-IN',{hour:'2-digit',minute:'2-digit'});
  const mrpSaving = items.reduce((s,i)=>s+(i.qty*((i.mrp||i.price)-i.price)),0);
  const D         = '-'.repeat(32);

  return (
    <div style={{fontFamily:'monospace',width:'280px',padding:'8px',margin:'0 auto',background:'white',fontSize:'12px',lineHeight:'1.7'}}>
      <div style={{textAlign:'center',marginBottom:'4px'}}>
        <div style={{fontSize:'14px',fontWeight:'900',textTransform:'uppercase'}}>{shop}</div>
        {address   && <div style={{fontSize:'10px',color:'#555'}}>{address}</div>}
        {shopPhone && <div style={{fontSize:'10px'}}>PH: {shopPhone}</div>}
        {shopGstin && <div style={{fontSize:'10px',fontWeight:'700'}}>GST: {shopGstin}</div>}
      </div>
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      <div style={{fontSize:'10px',margin:'3px 0'}}>
        <div style={{display:'flex',justifyContent:'space-between'}}>
          <span>User: ADMIN</span>
          <span>Bill#: {bill.billNumber||bill.bill_number}</span>
        </div>
        <div style={{display:'flex',justifyContent:'space-between'}}>
          <span>Time: {timeNow}</span>
          <span>Date: {today}</span>
        </div>
      </div>
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      {/* ✅ Customer info in thermal */}
      {(bill.customerName||bill.customer_name) && (
        <div style={{fontSize:'10px',margin:'3px 0'}}>
          <div><b>To:</b> {bill.customerName||bill.customer_name}</div>
          {(bill.customerPhone||bill.customer_phone) && (
            <div>📱 {bill.customerPhone||bill.customer_phone}</div>
          )}
          {(bill.customerAddress||bill.customer_address) && (
            <div>{bill.customerAddress||bill.customer_address}</div>
          )}
        </div>
      )}
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      <div style={{fontSize:'10px',fontWeight:'700',display:'grid',gridTemplateColumns:'auto 25px 40px 35px 42px',gap:'2px',margin:'2px 0'}}>
        <span>Item</span><span>Qty</span>
        <span style={{textAlign:'right'}}>Rate</span>
        <span style={{textAlign:'right'}}>MRP</span>
        <span style={{textAlign:'right'}}>Amt</span>
      </div>
      {items.map((item,i)=>(
        <div key={i} style={{borderBottom:'1px dashed #eee',paddingBottom:'2px',marginBottom:'2px'}}>
          <div style={{fontSize:'11px',fontWeight:'600'}}>{item.name_tamil||item.name}</div>
          <div style={{fontSize:'10px',display:'grid',gridTemplateColumns:'auto 25px 40px 35px 42px',gap:'2px',color:'#555'}}>
            <span></span>
            <span>{item.qty}</span>
            <span style={{textAlign:'right'}}>{Number(item.price).toFixed(2)}</span>
            <span style={{textAlign:'right'}}>{Number(item.mrp||item.price).toFixed(2)}</span>
            <span style={{textAlign:'right',fontWeight:'700'}}>{(item.qty*item.price).toFixed(2)}</span>
          </div>
        </div>
      ))}
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      <div style={{fontSize:'11px',margin:'4px 0'}}>
        <div style={{display:'flex',justifyContent:'space-between'}}>
          <span>Total Qty</span><span><b>{items.reduce((s,i)=>s+i.qty,0)}</b></span>
        </div>
        {gstRate>0 && <>
          <div style={{display:'flex',justifyContent:'space-between',color:'#666'}}>
            <span>CGST {gstRate/2}%</span><span>₹{(gstAmt/2).toFixed(2)}</span>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',color:'#666'}}>
            <span>SGST {gstRate/2}%</span><span>₹{(gstAmt/2).toFixed(2)}</span>
          </div>
        </>}
      </div>
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      <div style={{display:'flex',justifyContent:'space-between',fontWeight:'900',fontSize:'14px',margin:'4px 0'}}>
        <span>Net Amount : R</span><span>{Number(grandTotal).toFixed(2)}</span>
      </div>
      {mrpSaving > 0 && <>
        <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
        <div style={{display:'flex',justifyContent:'space-between',fontSize:'12px',color:'#27ae60',fontWeight:'700'}}>
          <span>TODAY SAVING</span><span>{mrpSaving.toFixed(2)}</span>
        </div>
      </>}
      <div style={{fontSize:'10px',textAlign:'center'}}>{D}</div>
      <div style={{textAlign:'center',fontSize:'10px',margin:'4px 0'}}>
        <div style={{fontWeight:'700'}}>நன்றி! மீண்டும் வாருங்கள்! 🙏</div>
        <div style={{color:'#888'}}>JSMSTOCK.COM</div>
      </div>
    </div>
  );
}

function PrintModal({ bill, onClose, isPremium = false }) {
  const [printType, setPrintType] = useState('a4');
  const printRef = useRef();

  const handleBrowserPrint = () => window.print();
  const handlePDFDownload = () => {
    const originalTitle = document.title;
    document.title = `Bill_${bill.billNumber}`;
    window.print();
    document.title = originalTitle;
  };
  const handleThermalPrint = () => window.print();

  if (!bill) return null;
  return (
    <>
      <style>{PRINT_STYLE}</style>
      <div
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}
        onClick={e => e.target === e.currentTarget && onClose()}
      >
        <div style={{ background: 'white', borderRadius: '16px', width: '100%', maxWidth: '820px', maxHeight: '90vh', overflow: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', background: '#2c3e50', borderRadius: '16px 16px 0 0' }}>
            <h2 style={{ margin: 0, color: 'white', fontSize: '18px' }}>🖨️ Bill Print / Download</h2>
            <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white', width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', fontSize: '18px' }}>✕</button>
          </div>
          <div style={{ padding: '16px 24px', borderBottom: '1px solid #eee', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {[
              { id: 'a4',      label: '🖨️ A4 Print',      desc: 'Normal printer' },
              { id: 'pdf',     label: '📄 PDF Download',  desc: 'Save as PDF' },
              { id: 'thermal', label: '🧾 Thermal 80mm',  desc: 'Thermal printer' },
            ].map(t => (
              <button key={t.id} onClick={() => setPrintType(t.id)}
                style={{ padding: '10px 18px', borderRadius: '8px', border: `2px solid ${printType === t.id ? '#2c3e50' : '#ddd'}`, background: printType === t.id ? '#2c3e50' : 'white', color: printType === t.id ? 'white' : '#555', cursor: 'pointer', fontWeight: '600', fontSize: '14px', textAlign: 'left' }}>
                <div>{t.label}</div>
                <div style={{ fontSize: '11px', opacity: 0.7 }}>{t.desc}</div>
              </button>
            ))}
          </div>
          <div style={{ padding: '24px', background: '#f5f5f5', display: 'flex', justifyContent: 'center' }}>
            <div id="bill-print-area" ref={printRef}
              style={{ background: 'white', padding: '16px', borderRadius: '8px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', display: 'inline-block' }}>
              {printType === 'thermal'
                ? isPremium
                  ? <PremiumThermalBill bill={bill} />
                  : <ThermalBill bill={bill} />
                : isPremium
                  ? <PremiumA4Bill bill={bill} />
                  : <A4Bill bill={bill} />
              }
            </div>
          </div>
          <div style={{ padding: '16px 24px', borderTop: '1px solid #eee', display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
            <button onClick={onClose}
              style={{ padding: '11px 22px', borderRadius: '8px', border: '1px solid #ddd', background: 'white', cursor: 'pointer', fontWeight: '600', color: '#555' }}>
              ரத்து
            </button>
            {printType === 'a4' && (
              <button onClick={handleBrowserPrint}
                style={{ padding: '11px 22px', borderRadius: '8px', border: 'none', background: '#2c3e50', color: 'white', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}>
                🖨️ Print பண்ணு
              </button>
            )}
            {printType === 'pdf' && (
              <button onClick={handlePDFDownload}
                style={{ padding: '11px 22px', borderRadius: '8px', border: 'none', background: '#e74c3c', color: 'white', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}>
                📄 PDF சேமி (Print → Save as PDF)
              </button>
            )}
            {printType === 'thermal' && (
              <button onClick={handleThermalPrint}
                style={{ padding: '11px 22px', borderRadius: '8px', border: 'none', background: '#27ae60', color: 'white', cursor: 'pointer', fontWeight: '700', fontSize: '15px' }}>
                🧾 Thermal Print
              </button>
            )}
          </div>
          {printType === 'pdf' && (
            <div style={{ padding: '12px 24px', background: '#fff8e1', borderTop: '1px solid #ffc107', fontSize: '13px', color: '#856404', borderRadius: '0 0 16px 16px' }}>
              💡 Print dialog-ல் "Destination" = "Save as PDF" select பண்ணுங்கள்!
            </div>
          )}
          {printType === 'thermal' && (
            <div style={{ padding: '12px 24px', background: '#e8f5e9', borderTop: '1px solid #27ae60', fontSize: '13px', color: '#2e7d32', borderRadius: '0 0 16px 16px' }}>
              💡 Printer-ல் 80mm thermal paper use பண்ணுங்கள்! Paper width = 72-80mm set பண்ணுங்கள்!
            </div>
          )}
        </div>
      </div>
    </>
  );
}

// ═══════════════════════════════════════════
// MAIN BILLING COMPONENT
// ═══════════════════════════════════════════
function Billing() {
  const [items, setItems]                   = useState([]);
  const [billItems, setBillItems]           = useState([]);
  const [customer, setCustomer]             = useState('');
  const [customerPhone, setCustomerPhone]   = useState('');
  const [customerGstin, setCustomerGstin]   = useState('');
  const [gstRate, setGstRate]               = useState(0);
  const [customGst, setCustomGst]           = useState('');
  const [isCustomGst, setIsCustomGst]       = useState(false);
  const [discount, setDiscount]             = useState(0);
  const [message, setMessage]               = useState('');
  const [error, setError]                   = useState('');
  const [lastBill, setLastBill]             = useState(null);
  const [search, setSearch]                 = useState('');
  const [bills, setBills]                   = useState([]);
  const [activeTab, setActiveTab]           = useState('create');
  const [showPrint, setShowPrint]           = useState(false);
  const [printBill, setPrintBill]           = useState(null);
  const [shopName,    setShopName]    = useState('என் கடை'); // ✅ CHANGE 3
  // ✅ Premium states
  const [shopAddress, setShopAddress] = useState('');
  const [shopPhone,   setShopPhone]   = useState('');
  const [shopGstin,   setShopGstin]   = useState('');
  const [isPremium,   setIsPremium]   = useState(false);
  // ✅ Barcode scan states
  const [barcodeInput, setBarcodeInput] = useState('');
  const [barcodeMsg,   setBarcodeMsg]   = useState('');
  const barcodeRef = useRef(null);

  useEffect(() => {
    api.get('/items/').then(res => setItems(res.data || [])).catch(() => {});
    api.get('/billing/').then(res => setBills(res.data || [])).catch(() => {});
    api.get('/auth/me').then(res => {          // ✅ CHANGE 4
      setShopName(res.data.shop_name || 'என் கடை');
      setShopAddress(res.data.shop_address || '');
      setShopPhone(res.data.shop_phone   || '');
      setShopGstin(res.data.shop_gstin   || '');
      const plan = res.data.account_type || 'pro';
      setIsPremium(plan === 'premium' || plan === 'business');
    }).catch(() => {});
  }, []);

  const filtered = items.filter(i =>
    i.name?.toLowerCase().includes(search.toLowerCase()) ||
    i.name_tamil?.includes(search)
  );

  // ✅ Barcode scan handler — called on Enter key
  const handleBarcodeScan = (e) => {
    if (e.key !== 'Enter') return;
    const code = barcodeInput.trim();
    if (!code) return;
    setBarcodeInput('');

    // 1. Check local items list first (fast, no API call)
    const found = items.find(i => i.barcode === code && i.quantity > 0);
    if (found) {
      addToBill(found);
      setBarcodeMsg(`✅ ${found.name_tamil || found.name} added!`);
      setTimeout(() => setBarcodeMsg(''), 2000);
      return;
    }

    // 2. Fallback: API call (for freshly added items not yet in state)
    api.get(`/items/barcode/${encodeURIComponent(code)}`)
      .then(res => {
        addToBill(res.data);
        // Refresh items list so next scan is faster
        api.get('/items/').then(r => setItems(r.data || []));
        setBarcodeMsg(`✅ ${res.data.name_tamil || res.data.name} added!`);
        setTimeout(() => setBarcodeMsg(''), 2000);
      })
      .catch(() => {
        setBarcodeMsg(`❌ Barcode "${code}" not found!`);
        setTimeout(() => setBarcodeMsg(''), 3000);
      });
  };

  const addToBill = (item) => {
    if (item.quantity <= 0) { alert('இருப்பு இல்லை!'); return; }
    const existing = billItems.find(b => b.id === item.id);
    if (existing) {
      setBillItems(billItems.map(b => b.id === item.id ? { ...b, qty: parseFloat((b.qty + 1).toFixed(2)) } : b));
    } else {
      setBillItems([...billItems, { ...item, qty: 1 }]);
    }
  };

  const removeFromBill = (id) => setBillItems(billItems.filter(b => b.id !== id));

  const updateQty = (id, val) => {
    const qty = parseFloat(val);
    if (isNaN(qty) || qty <= 0) return;
    setBillItems(billItems.map(b => b.id === id ? { ...b, qty } : b));
  };

  const effectiveGst  = isCustomGst ? (parseFloat(customGst) || 0) : gstRate;
  const subtotal      = billItems.reduce((sum, b) => sum + (b.price * b.qty), 0);
  const discountAmt   = subtotal * (discount / 100);
  const afterDiscount = subtotal - discountAmt;
  const gstAmount     = afterDiscount * (effectiveGst / 100);
  const grandTotal    = afterDiscount + gstAmount;

  const handleGstSelect = (value) => {
    if (value === -1) { setIsCustomGst(true); setGstRate(0); }
    else { setIsCustomGst(false); setCustomGst(''); setGstRate(value); }
  };

  const sendWhatsApp = (phone, data) => {
    const normItems = normaliseItems(data.items);
    const itemsList = normItems.map(i =>
      `▪️ ${i.name_tamil || i.name}: ${i.qty} × ₹${i.price} = ₹${(i.qty * i.price).toFixed(2)}`
    ).join('\n');
    const discLine = data.discount > 0 ? `\n🏷️ Discount (${data.discount}%): -₹${data.discountAmt.toFixed(2)}` : '';
    const gstLine  = data.gstRate  > 0 ? `\n📋 GST (${data.gstRate}%): ₹${data.gstAmount.toFixed(2)}` : '';
    const msg = `🧾 *${shopName} Bill*\n━━━━━━━━━━━━━━━\n📋 Bill No: ${data.billNumber}\n👤 ${data.customerName || ''}\n━━━━━━━━━━━━━━━\n${itemsList}\n━━━━━━━━━━━━━━━\n💵 Subtotal: ₹${data.subtotal.toFixed(2)}${discLine}${gstLine}\n💰 *மொத்தம்: ₹${data.grandTotal.toFixed(2)}*\n━━━━━━━━━━━━━━━\nநன்றி! 🙏\nPowered by JSMSTOCK.COM`;
    window.open(`https://wa.me/91${phone.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  // ✅ CHANGE 5 — inject shopName into every bill before print
  const openPrint = (bill) => {
    // ✅ Include all customer + shop details for premium bill
    setPrintBill({
      ...bill,
      // Shop details (premium header)
      shopName,
      shopAddress,
      shopPhone,
      shopGstin,
      // Normalize customer fields
      customerName:    bill.customerName    || bill.customer_name    || '',
      customerPhone:   bill.customerPhone   || bill.customer_phone   || '',
      customerAddress: bill.customerAddress || bill.customer_address || '',
      customerGstin:   bill.customerGstin   || bill.customer_gstin   || '',
    });
    setShowPrint(true);
  };

  const buildHistoryBillData = (b) => {
    const rawItems   = b.bill_items || b.items || [];
    const normItems  = normaliseItems(rawItems);
    const sub        = normItems.reduce((s, i) => s + i.qty * i.price, 0);
    const gRate      = parseFloat(b.gst_rate)    || 0;
    const disc       = parseFloat(b.discount)    || 0;
    const discAmt    = sub * (disc / 100);
    const afterDisc  = sub - discAmt;
    const gAmt       = afterDisc * (gRate / 100);
    const grand      = parseFloat(b.total_amount) || (afterDisc + gAmt);
    return {
      billNumber:    b.bill_number,
      customerName:  b.customer_name,
      customerPhone: b.customer_phone,
      customerGstin: b.customer_gstin,
      items:         normItems,
      subtotal:      sub,
      discount:      disc,
      discountAmt:   discAmt,
      gstRate:       gRate,
      gstAmount:     parseFloat(b.gst_amount) || gAmt,
      grandTotal:    grand,
      shopName,      // ✅ CHANGE 6
    };
  };

  const saveBill = () => {
    if (!customer)              { setError('வாடிக்கையாளர் பெயர் போடுங்கள்!'); return; }
    if (billItems.length === 0) { setError('Items சேர்க்கவில்லை!'); return; }

    api.post('/billing/', {
      customer_name:  customer,
      customer_phone: customerPhone,
      customer_gstin: customerGstin,
      gst_rate:       effectiveGst,
      total_amount:   grandTotal,
      items: billItems.map(b => ({ item_id: b.id, quantity: b.qty, price: b.price }))
    })
    .then(res => {
      const billData = {
        billNumber:    res.data.bill_number,
        customerName:  customer,
        customerPhone,
        customerGstin,
        items:         [...billItems],
        subtotal, discountAmt, discount,
        gstRate:       effectiveGst,
        gstAmount,
        grandTotal,
        phone:         customerPhone,
        shopName,      // ✅ CHANGE 7
      };
      setMessage(`✅  Bill #${res.data.bill_number} ready!`);
      setError('');
      setLastBill(billData);
      setBillItems([]); setCustomer(''); setCustomerPhone('');
      setCustomerGstin(''); setGstRate(0);
      setCustomGst(''); setIsCustomGst(false); setDiscount(0);
      api.get('/billing/').then(r => setBills(r.data || []));
      setTimeout(() => setMessage(''), 5000);
    })
    .catch(err => setError('பிழை: ' + (err.response?.data?.detail || err.message)));
  };

  return (
    <div style={s.page}>
      <h1 style={s.title}>பில்லிங் 🧾</h1>

      <div style={s.tabs}>
        <button style={{ ...s.tab, ...(activeTab === 'create'  ? s.tabActive : {}) }} onClick={() => setActiveTab('create')}>➕ புது பில்</button>
        <button style={{ ...s.tab, ...(activeTab === 'history' ? s.tabActive : {}) }} onClick={() => setActiveTab('history')}>📋 பில் வரலாறு ({bills.length})</button>
      </div>

      {activeTab === 'create' && (
        <div style={s.layout}>
          <div style={s.leftPanel}>
            <h3 style={s.panelTitle}>பொருட்கள் தேர்வு</h3>

            {/* ✅ BARCODE SCAN INPUT */}
            <div style={{marginBottom:'10px'}}>
              <div style={{fontSize:'11px',fontWeight:'700',color:'#666',marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.5px'}}>
                📷 Barcode Scan / Type
              </div>
              <div style={{display:'flex',gap:'6px'}}>
                <input
                  ref={barcodeRef}
                  style={{
                    ...s.search, marginBottom:0, flex:1,
                    border:'2px solid #3498db',
                    background:'#EBF5FB',
                    fontWeight:'700', letterSpacing:'1px',
                  }}
                  placeholder="🔍 Scan barcode or type & press Enter"
                  value={barcodeInput}
                  onChange={e => setBarcodeInput(e.target.value)}
                  onKeyDown={handleBarcodeScan}
                  autoComplete="off"
                />
                <button
                  onClick={() => barcodeRef.current?.focus()}
                  style={{
                    background:'#3498db', color:'white', border:'none',
                    borderRadius:'8px', padding:'0 12px',
                    cursor:'pointer', fontSize:'18px', flexShrink:0,
                  }}
                  title="Click then scan">
                  📷
                </button>
              </div>
              {barcodeMsg && (
                <div style={{
                  marginTop:'4px', padding:'6px 10px', borderRadius:'6px',
                  fontSize:'13px', fontWeight:'600',
                  background: barcodeMsg.startsWith('✅') ? '#e8f8f0' : '#fff0f0',
                  color:      barcodeMsg.startsWith('✅') ? '#27ae60'  : '#e74c3c',
                  border: `1px solid ${barcodeMsg.startsWith('✅') ? '#27ae60' : '#e74c3c'}`,
                }}>
                  {barcodeMsg}
                </div>
              )}
            </div>

            <input style={s.search} placeholder="🔍 பெயரால் தேடுங்கள்..." value={search} onChange={e => setSearch(e.target.value)} />
            <div style={s.itemsList}>
              {filtered.map(item => (
                <div key={item.id} style={{ ...s.itemCard, ...(item.quantity <= 0 ? s.outOfStock : {}) }}>
                  <div style={{ flex: 1 }}>
                    <div style={s.itemName}>{item.name_tamil || item.name}</div>
                    {item.name_tamil && <div style={s.itemSub}>{item.name}</div>}
                    <div style={s.itemMeta}>
                      ₹{item.price}
                      {item.mrp && item.mrp > item.price && (
                        <span style={{color:'#e74c3c',textDecoration:'line-through',marginLeft:'6px',fontSize:'11px'}}>₹{item.mrp}</span>
                      )}
                      {' '}| இருப்பு: {Number(item.quantity) % 1 === 0 ? item.quantity : Number(item.quantity).toFixed(2)}
                    </div>
                  </div>
                  <button
                    style={{ ...s.addBtn, ...(item.quantity <= 0 ? s.addBtnDis : {}) }}
                    onClick={() => addToBill(item)} disabled={item.quantity <= 0}>
                    {item.quantity <= 0 ? '❌' : '➕'}
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div style={s.rightPanel}>
            <h3 style={s.panelTitle}>இன்றைய பில் 📄</h3>
            {message && <div style={s.successBox}>{message}</div>}
            {error   && <div style={s.errorBox}>{error} <span style={{ cursor: 'pointer' }} onClick={() => setError('')}>✕</span></div>}

            <div style={s.section}>
              <div style={s.secLabel}>👤 வாடிக்கையாளர்</div>
              <input style={s.input} placeholder="வாடிக்கையாளர் பெயர் *" value={customer} onChange={e => setCustomer(e.target.value)} />
              <input style={s.input} placeholder="📱 WhatsApp" type="tel" maxLength={10} value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} />
              <input style={s.input} placeholder="GSTIN (விரும்பினால்)" value={customerGstin} onChange={e => setCustomerGstin(e.target.value)} />
            </div>

            <div style={s.section}>
              <div style={s.secLabel}>🏷️ GST Rate</div>
              <div style={s.gstRow}>
                {GST_PRESETS.map(r => (
                  <button key={r.value}
                    style={{ ...s.gstBtn, ...((isCustomGst && r.value === -1) || (!isCustomGst && gstRate === r.value) ? s.gstActive : {}) }}
                    onClick={() => handleGstSelect(r.value)}>
                    {r.label}
                  </button>
                ))}
              </div>
              {isCustomGst && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px' }}>
                  <input
                    style={{ ...s.input, border: '2px solid #3498db', fontWeight: '700' }}
                    placeholder="Custom GST %" type="number" step="0.5" min="0" max="100"
                    value={customGst} onChange={e => setCustomGst(e.target.value)} autoFocus />
                  <span style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50' }}>%</span>
                </div>
              )}
            </div>

            <div style={s.section}>
              <div style={s.secLabel}>💸 Discount</div>
              <div style={s.gstRow}>
                {[0, 5, 10, 15, 20].map(d => (
                  <button key={d} style={{ ...s.gstBtn, ...(discount === d ? s.gstActive : {}) }} onClick={() => setDiscount(d)}>
                    {d === 0 ? 'இல்லை' : `${d}%`}
                  </button>
                ))}
              </div>
            </div>

            <div style={s.section}>
              <div style={s.secLabel}>🛒 தேர்ந்த பொருட்கள்</div>
              {billItems.length === 0 ? (
                <p style={s.emptyText}>← பொருட்கள் select பண்ணுங்கள்</p>
              ) : (
                <>
                  {billItems.map(b => (
                    <div key={b.id} style={s.billRow}>
                      <div style={{ flex: 1 }}>
                        <div style={s.billName}>{b.name_tamil || b.name}</div>
                        <div style={s.billPrice}>₹{b.price} each</div>
                      </div>
                      <input type="number" step="0.25" min="0.25" style={s.qtyInput}
                        value={b.qty} onChange={e => updateQty(b.id, e.target.value)} />
                      <div style={s.billTotal}>₹{(b.qty * b.price).toFixed(2)}</div>
                      <button style={s.removeBtn} onClick={() => removeFromBill(b.id)}>✕</button>
                    </div>
                  ))}
                  <div style={s.calcBox}>
                    <div style={s.calcRow}><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                    {discount > 0 && <div style={{ ...s.calcRow, color: '#27ae60' }}><span>Discount ({discount}%)</span><span>-₹{discountAmt.toFixed(2)}</span></div>}
                    {discount > 0 && <div style={s.calcRow}><span>After Discount</span><span>₹{afterDiscount.toFixed(2)}</span></div>}
                    {effectiveGst > 0 && <div style={{ ...s.calcRow, color: '#e67e22' }}><span>GST ({effectiveGst}%)</span><span>+₹{gstAmount.toFixed(2)}</span></div>}
                    <div style={s.calcDivider} />
                    <div style={{ ...s.calcRow, ...s.grandRow }}><span>💰 மொத்தம்</span><span>₹{grandTotal.toFixed(2)}</span></div>
                    {effectiveGst > 0 && (
                      <div style={s.gstBreakdown}>
                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#856404', marginBottom: '4px' }}>GST Breakdown:</div>
                        <div style={s.gstBreakRow}><span>CGST ({effectiveGst / 2}%)</span><span>₹{(gstAmount / 2).toFixed(2)}</span></div>
                        <div style={s.gstBreakRow}><span>SGST ({effectiveGst / 2}%)</span><span>₹{(gstAmount / 2).toFixed(2)}</span></div>
                      </div>
                    )}
                  </div>
                  <button style={s.saveBtn} onClick={saveBill}>💾 Bill சேமிக்க</button>
                </>
              )}
            </div>

            {lastBill && (
              <div style={s.waBox}>
                <p style={s.waTitle}>✅  Bill #{lastBill.billNumber} Ready!</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {lastBill.phone && (
                    <button style={s.waBtn} onClick={() => sendWhatsApp(lastBill.phone, lastBill)}>
                      📱 WhatsApp-ல் அனுப்பு
                    </button>
                  )}
                  <button style={s.printBtnA4} onClick={() => openPrint(lastBill)}>
                    🖨️ Print / PDF Download
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === 'history' && (
        <div style={s.tableWrap}>
          <table style={s.table}>
            <thead>
              <tr style={s.thead}>
                <th style={s.th}>பில் எண்</th>
                <th style={s.th}>வாடிக்கையாளர்</th>
                <th style={s.th}>தொலைபேசி</th>
                <th style={s.th}>GST%</th>
                <th style={s.th}>மொத்தம்</th>
                <th style={s.th}>தேதி</th>
                <th style={s.th}>Print</th>
              </tr>
            </thead>
            <tbody>
              {[...bills].reverse().map((b, i) => (
                <tr key={b.id} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#f8f9fa' }}>
                  <td style={s.th2}><strong>{b.bill_number}</strong></td>
                  <td style={s.th2}>{b.customer_name}</td>
                  <td style={s.th2}>{b.customer_phone || '—'}</td>
                  <td style={s.th2}>{b.gst_rate > 0 ? `${b.gst_rate}%` : '—'}</td>
                  <td style={s.th2}><strong>₹{parseFloat(b.total_amount).toFixed(2)}</strong></td>
                  <td style={s.th2}>{new Date(b.created_at).toLocaleDateString('ta-IN')}</td>
                  <td style={s.th2}>
                    <button
                      style={{ background: '#2c3e50', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}
                      onClick={() => openPrint(buildHistoryBillData(b))}>
                      🖨️ Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showPrint && printBill && (
        <PrintModal bill={printBill} isPremium={isPremium} onClose={() => { setShowPrint(false); setPrintBill(null); }} />
      )}
    </div>
  );
}

const s = {
  page:          { padding: '20px', maxWidth: '1300px', margin: '0 auto' },
  title:         { color: '#2c3e50', marginBottom: '20px' },
  tabs:          { display: 'flex', gap: '10px', marginBottom: '20px' },
  tab:           { padding: '10px 20px', border: '2px solid #ddd', borderRadius: '8px', cursor: 'pointer', background: 'white', fontWeight: '600', fontSize: '14px', color: '#666' },
  tabActive:     { borderColor: '#2c3e50', background: '#2c3e50', color: 'white' },
  layout:        { display: 'grid', gridTemplateColumns: '1fr 1.15fr', gap: '20px' },
  leftPanel:     { background: '#f9f9f9', borderRadius: '12px', padding: '20px', border: '1px solid #eee' },
  rightPanel:    { background: '#f9f9f9', borderRadius: '12px', padding: '20px', border: '1px solid #eee' },
  panelTitle:    { fontSize: '16px', fontWeight: '700', color: '#2c3e50', marginBottom: '14px' },
  search:        { width: '100%', padding: '9px 12px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', marginBottom: '12px', boxSizing: 'border-box' },
  itemsList:     { maxHeight: '480px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px' },
  itemCard:      { display: 'flex', alignItems: 'center', gap: '10px', background: 'white', padding: '12px', borderRadius: '8px', border: '1px solid #eee' },
  outOfStock:    { opacity: 0.5 },
  itemName:      { fontWeight: '600', fontSize: '14px', color: '#2c3e50' },
  itemSub:       { fontSize: '11px', color: '#999' },
  itemMeta:      { fontSize: '12px', color: '#666', marginTop: '2px' },
  addBtn:        { background: '#2ecc71', color: 'white', border: 'none', borderRadius: '6px', padding: '8px 14px', cursor: 'pointer', fontSize: '16px', flexShrink: 0 },
  addBtnDis:     { background: '#ccc', cursor: 'not-allowed' },
  section:       { marginBottom: '16px' },
  secLabel:      { fontSize: '12px', fontWeight: '700', color: '#666', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input:         { display: 'block', width: '100%', padding: '10px 12px', margin: '6px 0', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', background: 'white' },
  gstRow:        { display: 'flex', gap: '6px', flexWrap: 'wrap' },
  gstBtn:        { padding: '7px 11px', borderRadius: '6px', border: '1.5px solid #ddd', background: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: '600', color: '#555' },
  gstActive:     { borderColor: '#2c3e50', background: '#2c3e50', color: 'white' },
  emptyText:     { color: '#999', fontSize: '14px', padding: '10px 0' },
  billRow:       { display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 0', borderBottom: '1px solid #eee' },
  billName:      { fontSize: '14px', fontWeight: '600', color: '#2c3e50' },
  billPrice:     { fontSize: '12px', color: '#888' },
  billTotal:     { fontWeight: '700', color: '#2c3e50', minWidth: '75px', textAlign: 'right' },
  qtyInput:      { width: '68px', padding: '6px 8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', textAlign: 'center' },
  removeBtn:     { background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: '16px' },
  calcBox:       { background: 'white', borderRadius: '10px', padding: '16px', margin: '14px 0', border: '2px solid #eee' },
  calcRow:       { display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: '14px', color: '#555' },
  calcDivider:   { borderTop: '2px solid #2c3e50', margin: '8px 0' },
  grandRow:      { fontSize: '20px', fontWeight: '900', color: '#2c3e50' },
  gstBreakdown:  { background: '#fff8e1', borderRadius: '8px', padding: '10px', marginTop: '12px', border: '1px solid #ffc107' },
  gstBreakRow:   { display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#856404', padding: '3px 0' },
  saveBtn:       { width: '100%', background: '#2c3e50', color: 'white', border: 'none', padding: '14px', borderRadius: '8px', fontSize: '16px', fontWeight: '700', cursor: 'pointer' },
  successBox:    { background: '#e8f8f0', border: '1px solid #27ae60', color: '#27ae60', padding: '10px 14px', borderRadius: '8px', marginBottom: '12px', fontWeight: '600' },
  errorBox:      { background: '#fff0f0', border: '1px solid #e74c3c', color: '#e74c3c', padding: '10px 14px', borderRadius: '8px', marginBottom: '12px', display: 'flex', justifyContent: 'space-between' },
  waBox:         { background: '#e8f5e9', borderRadius: '10px', padding: '16px', textAlign: 'center', marginTop: '10px' },
  waTitle:       { color: '#27ae60', fontWeight: '700', marginBottom: '10px' },
  waBtn:         { background: '#25D366', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', width: '100%' },
  printBtnA4:    { background: '#2c3e50', color: 'white', border: 'none', padding: '12px 24px', borderRadius: '8px', fontSize: '15px', fontWeight: '700', cursor: 'pointer', width: '100%' },
  tableWrap:     { background: 'white', borderRadius: '12px', overflow: 'auto', border: '1px solid #eee' },
  table:         { width: '100%', borderCollapse: 'collapse' },
  thead:         { background: '#2c3e50' },
  th:            { padding: '12px 16px', color: 'white', fontSize: '13px', fontWeight: '600', textAlign: 'left' },
  th2:           { padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '14px' },
};

export default Billing;

